import { Outlet } from 'react-router-dom';
import { useMe, useSites } from '../api/hooks';
import { ErrorState, Loading } from '../components/States';
import { AppShell } from './AppShell';
import { mspNav, tenantNav } from './nav';

/** Shell for pages that belong to the signed-in person rather than a tenant. */
export function AccountLayout({ mspName }: { mspName: string }) {
  const me = useMe();
  const tenant = me.data && !me.data.isMsp ? me.data.tenants[0] : undefined;
  const sites = useSites(tenant?.tenantId ?? '');
  if (me.isPending) return <Loading label="Loading…" />;
  if (me.isError) return <ErrorState error={me.error} retry={() => me.refetch()} />;
  const sections = tenant
    ? tenantNav(`/t/${tenant.tenantId}`, { canConfigure: me.data.role === 'tenant-admin' })
    : [mspNav()];
  return (
    <AppShell me={me.data} mspName={mspName} tenant={tenant} sites={tenant ? sites.data : undefined} sections={sections}>
      <div className="page">
        <Outlet />
      </div>
    </AppShell>
  );
}
